
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PregnancyConceptionCalculator from '@/components/SpecialCalculators/PregnancyCalculators/PregnancyConceptionCalculator';

const PregnancyConceptionCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/special" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to Special Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Pregnancy Conception Calculator</h1>
          <p className="text-gray-600 mb-6">
            Calculate your estimated conception date based on your due date.
          </p>
        </div>
        
        <div className="mb-8">
          <PregnancyConceptionCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Pregnancy Conception</h2>
          <p>
            Conception typically occurs around the time of ovulation, when a sperm fertilizes an egg.
            This calculator works backward from your due date to estimate when conception likely occurred.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Understanding Conception Timing</h3>
          <p>
            While a typical pregnancy lasts about 40 weeks (280 days) from the first day of the last menstrual period,
            conception usually happens about 2 weeks after that, around the time of ovulation. This means that from
            conception to birth is typically about 38 weeks (266 days).
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">The Fertile Window</h3>
          <p>
            The "fertile window" is the period during which pregnancy can occur. It includes:
          </p>
          <ul className="list-disc ml-6">
            <li>The 5 days before ovulation</li>
            <li>The day of ovulation itself</li>
          </ul>
          <p>
            Sperm can survive in the female reproductive tract for up to 5 days, while an egg is typically
            viable for about 24 hours after ovulation.
          </p>
          
          <div className="bg-blue-50 p-4 rounded-md mt-6">
            <h3 className="text-lg font-medium text-blue-800 mb-2">Calculating Accuracy</h3>
            <p className="text-blue-800">
              Remember that this calculator provides an estimate based on average pregnancy length.
              The actual conception date may vary based on when ovulation occurred, how long it took for the
              fertilized egg to implant, and other individual factors.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PregnancyConceptionCalculatorPage;
